import React, { useState } from 'react';
import CategoriesSection from './CategoriesSection';
import Aboutus from './Aboutus';

function Header() {
  const [showPdf, setShowPdf] = useState(false);

  const openPdf = () => {
    setShowPdf(true);
  };

  const closePdf = () => {
    setShowPdf(false);
  };

  return (
    <>
      <header>
        <div className="header-top">
          <div className="contact-info">
            <a href="mailto:names@belgeodesy.by">
              <img src="images/mail.png" alt="Email" /> enjoybymap@gmail.com
            </a>
            <a href="tel:+375298691959">
              <img src="images/phone.png" alt="Phone" /> +375 (29) 869-19-59
            </a>
          </div>
          
        </div>
        <div className="header-bottom">
          <a href="#" className="logo">
            <img src="images/logo-belarus.svg" alt="Логотип" />
          </a>
          <p className='text-spacing'>ENJOYBYMAP</p>
          <nav>
            <ul className='ul-header'>
              <li className='ul-header'><a href="#aboutus" className="click-link">О нас</a></li>
              <li className='ul-header'><button onClick={openPdf} className="pdf-link">Наши разработки</button></li>
              <li className='ul-header'><a href="#categories" className="click-link">Наши услуги</a></li>
            </ul>
          </nav>
        </div>
      </header>

      {/* Модальное окно для PDF */}
      {showPdf && (
        <div className="pdf-modal">
          <div className="pdf-modal-content">
            <button className="pdf-modal-close" onClick={closePdf}>
              &times;
            </button>
            <iframe 
              src="/Commercial_proposal.pdf" 
              title="Документ предприятия"
              width="100%" 
              height="100%"
              frameBorder="0"
            >
              Ваш браузер не поддерживает PDF. Вы можете 
              <a href="/Commercial_proposal.pdf">скачать файл</a>.
            </iframe>
          </div>
        </div>
      )}
    </>
  );
}

export default Header;